import { Box } from '@mui/material';
import * as React from 'react';
import { useRouteMatch } from 'react-router';
import { Route } from 'react-router-dom';

import { PrivateRoute } from '~/components/Auth';
import { RedirectAuthenticatedLogin } from '~/scenes/LoginViews/components/RedirectAuthenticatedLogin';

export const LoginViewRouter = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <PrivateRoute
        path={`${path}/authenticated`}
        component={RedirectAuthenticatedLogin}
      />

      <Route exact path={path} render={() => <Box>Login Page... TBA</Box>} />
    </>
  );
};
